module.exports = __webpack_public_path__ + "static/media/icon-businessmodelcanvas.2c3fab63.svg";